import React from 'react';
import { StyledProgressIndicator, StyledTrack, StyledTrain } from './index.styles.js';
export const ProgressIndicator = ({ className, size = 'md', 'data-testid': dataTestId, variant = 'idle' }) => {
    const dimensions = size === 'lg' ? 48 : size === 'md' ? 32 : size;
    const radius = dimensions / 2;
    const strokeWidth = 3;
    return (React.createElement(StyledProgressIndicator, { viewBox: `0 0 ${dimensions} ${dimensions}`, className: className, role: "status", "aria-live": "polite", "data-testid": dataTestId, dimensions: dimensions },
        React.createElement(StyledTrack, { cx: radius, cy: radius, r: radius - strokeWidth / 2, variant: variant }),
        React.createElement(StyledTrain, { cx: radius, cy: radius, r: radius - strokeWidth / 2, dimensions: dimensions, variant: variant })));
};
ProgressIndicator.displayName = 'ProgressIndicator';
//# sourceMappingURL=index.js.map